/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * History object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var History = {
	title: document.title,
	notifications: 0,
	parseTitle: function (title) {
		return (this.notifications > 0 ? '(' + this.notifications + ') ' : '') + title;
	},
	changeTitle: function (title) {
		this.title = title;
		document.title = this.parseTitle(title);
	},
	replace: function () {
		
	},
	push: function (data, title, url) {
		history.pushState(data, title, url);
	},
	reloadNotifications: function () {
		document.title = this.parseTitle(this.title);
	}
};